var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 136,
    height: 120,
    viewBox: "0 0 136 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-House"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 136,
    height: 120
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "House",
    clipPath: "url(#clip-House)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_292",
    "data-name": "Group 292",
    transform: "translate(-886.485 -110.671)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M927.507,126.724a15.779,15.779,0,0,1,.986-5.011,4.612,4.612,0,0,1,4.658-2.424c6.188.565,10.658,1.088,11.8,2.73,1.117,1.614.039,5.529-1.747,12.012-1.041,3.782-2.3,8.367-3.612,14.141-3.777-4.308-7.647-8.471-11.6-12.719-.672-.722-1.355-1.457-2.035-2.189A16.1,16.1,0,0,0,927.507,126.724Z",
    transform: "translate(65.008 13.873)",
    fill: "#98b99d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M935.651,180.962c-7.328.711-14.827.2-22.076-.288-1.768-.123-3.562-.238-5.362-.34a1.408,1.408,0,0,0,.413-1.308,77.947,77.947,0,0,1-1.051-24.258c.149-.986.23-9.13.293-9.766a11.293,11.293,0,0,1,.17-1.357,13.671,13.671,0,0,1,2.916-.664l1.3-.228a105.447,105.447,0,0,1,31.437-.588c-.615,5.105-2.419,18.114-2.874,23.834-.4,4.93-.766,9.588-1.221,13.762a1.4,1.4,0,0,0,.261.965C938.078,180.8,936.634,180.868,935.651,180.962Z",
    transform: "translate(33.923 49.358)",
    fill: "#e6eeef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M988.2,183.292l.063,2.168a51.272,51.272,0,0,0,1.051,7.13c.882,4.637,1.978,10.407.735,12.826-2.411,4.71-19.477,5.657-28.144,6.028a1.385,1.385,0,0,0,.188-.554c.46-4.216.834-8.892,1.229-13.846.5-6.206,2.341-19.733,3.036-25.068a1.43,1.43,0,0,0-1.174-1.6,107.333,107.333,0,0,0-33.783.377l-1.281.225c-4.279.753-5.092,1.007-5.437,4.564-.06.594-.134,8.688-.275,9.609-1.193,7.83.217,21.281,1.085,25.293a1.4,1.4,0,0,0,.3.586c-2.8-.139-5.628-.225-8.442-.188-.714.01-1.86.081-3.272.173-4.232.269-17.1,1.091-18.8-1.378-.845-1.229-.094-6.808.267-9.489.2-1.5.374-2.791.395-3.625a163.047,163.047,0,0,1,1.71-21.6,1.375,1.375,0,0,0-.023-.416,15.083,15.083,0,0,0,4.948-1.878c4.318-2.691,8.955-10.048,13.048-16.534,1.844-2.924,3.586-5.686,4.9-7.323,2.286-2.853,4.185-5.275,5.843-7.391,6.039-7.7,8.8-11.22,15.575-16.893,2.108-1.768,3.853-2.511,5.333-2.27,2.542.411,4.684,3.884,6.954,7.566.41.664.826,1.339,1.258,2.014a208.379,208.379,0,0,0,14.167,19.911c1.731,2.2,3.58,4.559,5.762,7.459.771,1.023,1.619,2.233,2.54,3.546,2.8,4,6.2,8.85,10.21,12.541a1.413,1.413,0,0,0-.115.447C988,176.6,988.088,179.544,988.2,183.292Z",
    transform: "translate(14.826 18.541)",
    fill: "#98b99d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M1017.811,194.794a5.673,5.673,0,0,1-4.4,1.752c-7.516-1.274-13.886-10.289-18.54-16.874-.948-1.342-1.822-2.579-2.619-3.628-2.218-2.914-4.094-5.286-5.853-7.5a203.346,203.346,0,0,1-14.134-19.673c-.428-.667-.842-1.331-1.249-1.988-2.648-4.25-5.148-8.267-9.015-8.887a6.368,6.368,0,0,0-1.024-.081c-2.07,0-4.266.983-6.676,2.982-7.072,5.869-10.1,9.7-16.135,17.322-1.671,2.108-3.58,4.522-5.879,7.368-1.428,1.763-3.144,4.459-5.135,7.582-3.767,5.924-8.461,13.294-12.257,15.637-5.253,3.248-14.863,1.841-23.342.6-1.766-.256-3.458-.5-5.071-.7,12.268-17.013,37.465-49.716,60.189-72.723.652-.659,1.238-1.321,1.8-1.954,2.313-2.621,3.548-3.85,6.431-3.159,4.284,1.023,11.383,11.233,15.625,17.329,1.663,2.39,2.975,4.279,3.878,5.32,5.649,6.528,11.021,12.245,16.217,17.777,11.394,12.135,21.251,22.626,30.52,37.651C1021.064,190.688,1019.689,193.133,1017.811,194.794Z",
    transform: "translate(0 0.001)",
    fill: "#819b84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M926.417,112.613a18.007,18.007,0,0,1,10.514,7.728c2.532,4.022.625,8.811-4.252,6.089C928.391,124.034,926.236,117.161,926.417,112.613Z",
    transform: "translate(65.738 3.137)",
    fill: "#51924b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M948.63,110.671a26.645,26.645,0,0,0-15.553,11.437c-3.745,5.95-.923,13.035,6.29,9.007C945.712,127.569,948.9,117.4,948.63,110.671Z",
    transform: "translate(73.839 0)",
    fill: "#51924b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/House.223f879fcfc908f6760e9ac2948800c4.svg";
export { ForwardRef as ReactComponent };